/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React, { useState } from "react";
import { History, ChevronDown, ChevronUp } from "lucide-react";

const when = (iso) => { try { const d = new Date(iso); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; } catch { return iso || ""; } };

/* 合同付款期明细下方：付款期变更记录（谁 · 何时 · 改了哪一期的名称 / 条件 / 金额 / 顺序 / 增删）。默认折叠，显示最近 20 条 */
export const PlanChangeLog = ({ log, zh }) => {
  const [open, setOpen] = useState(false);
  if (!log?.length) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white" data-testid="signed-plan-log" data-count={log.length}>
      <button type="button" data-testid="signed-plan-log-toggle" onClick={() => setOpen((v) => !v)} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 w-full flex items-center gap-2 px-3 py-2 text-xs text-slate-600 hover:text-slate-900">
        <History className="h-3.5 w-3.5 text-slate-400" />
        <span className="font-semibold">{zh ? "付款期变更记录" : "Schedule change log"}</span>
        <span className="text-slate-400">· {log.length} {zh ? "次" : ""}</span>
        <span className="ml-auto text-[11px] text-slate-400">{zh ? "最近" : "Last"} {log[0]?.by} · {when(log[0]?.at)}</span>
        {open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
      </button>
      {open && (
        <ol className="border-t border-slate-100 divide-y divide-slate-50 max-h-72 overflow-y-auto">
          {log.map((e, i) => (
            <li key={`${e.at}-${i}`} className="px-3 py-2 text-[11px]" data-testid={`signed-plan-log-item-${i}`}>
              <p className="flex flex-wrap items-center gap-x-2 text-slate-500">
                <span className="font-semibold text-slate-700">{e.by}</span>
                <span>{when(e.at)}</span>
                <span className="text-slate-400">· {e.count} {zh ? "期" : "periods"} · {zh ? "合同额" : "total"} ${Number(e.contractAmount || 0).toLocaleString()}</span>
              </p>
              <ul className="mt-1 flex flex-wrap gap-1">
                {(e.changes || []).map((c, j) => <li key={j} className={`rounded-md px-1.5 py-0.5 ${/^删除/.test(c) ? "bg-rose-50 text-rose-700" : /顺序/.test(c) ? "bg-sky-50 text-sky-700" : /→默认$/.test(c) ? "bg-slate-100 text-slate-500" : "bg-amber-50 text-amber-800"}`}>{c}</li>)}
              </ul>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
